import http from '../config/http';
import routes from '../config/api_routes';

export const getEventoAtivo = () => { 
    return http(true).get(routes.qrcode.evento.ativo);
}

export const getQRCodesAtivos = () => { 
    return http(true).get(routes.qrcode.ativos);
}

export const getQRCodesComprados = () => { 
    return http().get(routes.qrcode.comprados);
}

export const getQRCodesComprar = ({ valorTotal, cartaoSelect, selected, estacaoOrigem, estacaoDestino }) => { 
    let obj = new FormData();
    obj.append("Value", valorTotal.toFixed(2));
    obj.append("CardPayId", cartaoSelect);
    obj.append("EstacaoOrigem", estacaoOrigem);
    obj.append("EstacaoDestino", estacaoDestino);
    selected.forEach((bilhete, i) => {
        obj.append(`QRCodes[${i}][idProduto]`, bilhete.idProduto.toString());
        obj.append(`QRCodes[${i}][nome]`, (bilhete.nome || '').toString());
        obj.append(`QRCodes[${i}][grupo]`, (bilhete.grupo.descricao || '').toString());
        obj.append(`QRCodes[${i}][grupoEN]`, (bilhete.grupo.descricaoEN || '').toString());
        obj.append(`QRCodes[${i}][descricao]`, bilhete.descricao);
        obj.append(`QRCodes[${i}][descricaoEN]`, bilhete.descricaoEN);
        obj.append(`QRCodes[${i}][cor]`, bilhete.cor);
        obj.append(`QRCodes[${i}][faixaInicial]`, bilhete.faixaInicial);
        obj.append(`QRCodes[${i}][faixaFinal]`, bilhete.faixaFinal);
        obj.append(`QRCodes[${i}][permiteUsoDuplicidade]`, bilhete.permiteUsoDuplicidade ? 'true' : 'false');
        obj.append(`QRCodes[${i}][tarifa]`, bilhete.tarifaAtiva.valor.toFixed(2));
        if(bilhete.alternativo) {
            obj.append(`QRCodes[${i}][alternativo][idProduto]`, bilhete.alternativo.idProduto.toString());
            obj.append(`QRCodes[${i}][alternativo][nome]`, bilhete.alternativo.nome);
            obj.append(`QRCodes[${i}][alternativo][faixaInicial]`, bilhete.alternativo.faixaInicial);
            obj.append(`QRCodes[${i}][alternativo][faixaFinal]`, bilhete.alternativo.faixaFinal);
            obj.append(`QRCodes[${i}][alternativo][descricao]`, bilhete.alternativo.descricao);
            obj.append(`QRCodes[${i}][alternativo][descricaoEN]`, bilhete.alternativo.descricaoEN);
            obj.append(`QRCodes[${i}][alternativo][grupo]`, bilhete.alternativo.grupo.descricao);
            obj.append(`QRCodes[${i}][alternativo][grupoEN]`, bilhete.alternativo.grupo.descricaoEN);
            obj.append(`QRCodes[${i}][alternativo][cor]`, bilhete.alternativo.cor);
        }
    });
    return http().post(routes.qrcode.comprar, obj);
}

export const getQRCodeDetalhe = (id) =>  {
    return http().get(routes.qrcode.detalhe.replace(':id', id));
}

export const getQRCodePDF = (qrcode) => {
    let obj = new FormData();
    obj.append("qrcode", qrcode);
    return http().post(routes.qrcode.pdf, obj, {
        responseType: 'blob'
    });
}

export const groupTickets = (tickets) => {
    let groups = [];
    tickets.produtos.forEach(ticket => {
      let index = groups.findIndex(group => group.id == ticket.grupo.idGrupo);
      if(index == -1)  {
        groups.push({
          id: ticket.grupo.idGrupo,
          nome: ticket.grupo.descricao,
          data: ticket.faixaInicial,
          cor: ticket.cor,
          faixaInicial: ticket.faixaInicial,
          faixaFinal: ticket.faixaFinal,
          bilhetes: []
        });
      }
    });
    groups = groups.map(grupo => {
      grupo.bilhetes = tickets.produtos.filter(produto => produto.grupo.idGrupo == grupo.id).sort((a, b) => a.sequencia - b.sequencia);
      return grupo;
    });
    return groups;
}

export default {
    getEventoAtivo,
    getQRCodesAtivos,
    getQRCodesComprados,
    getQRCodesComprar,
    getQRCodeDetalhe,
    getQRCodePDF,
    groupTickets,
}